import React, { useState, useEffect } from "react";
// import "./planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import {
  setCommercialQuickQuotes,
  setCommercialErrQuotes,
  setQuickQuotePost,
  getComQuickQuotePost,
  setCommercialDetails,
} from "../../../Redux/actions/CommercialSlice";
import axiosCommercial from "../../../Redux/axios/AxiosCommercial";
// import axios from "axios";
import {
  Button,
  Form,
  DatePicker,
  Radio,
  Select,
  Row,
  Col,
  message,
} from "antd/lib";
import moment from "moment";

export default function CommerRegDateUpdate({ setisModalReg, CommerDetail }) {
  const dispatch = useDispatch();
  const auth = CommerDetail?.commercialnum;
  const QuickQuotePost = useSelector(getComQuickQuotePost);
  const [loading, setLoading] = useState(false);

  const onFinish = (data) => {
    console.log("product data", data);
    // console.log("dateString",data.registrationDate)
    const updatedQuotePost = {
      ...QuickQuotePost,
      registrationDate: moment(data.registrationDate).format("YYYY-MM-DD"),
      policyHolderType: data.vechicleOwned,
      previousInsurerCode: data.customertype,
    };
    dispatch(
      setCommercialDetails({
        ...CommerDetail,
        RegYear: moment(data?.registrationYear).format("YYYY-MM-DD"),
      })
    );
    console.log(updatedQuotePost);
    setLoading(true);
    axiosCommercial
      .post(
        `v2/commercial_insurances/${auth?.commercial_insurance_id}/quick_quotes`,
        updatedQuotePost
      )
      .then((res) => {
        if (res.status === 200) {
          const data = res?.data?.data;
          //console.log("data-----------------",data)
          const errData = data?.filter(
            (item) => "status" in item && item.status === "failed"
          );
          dispatch(setCommercialErrQuotes(errData));
          const filteredData = data?.filter(
            (item) => "status" in item && item.status === "success"
          );
          const updatedData = filteredData?.map((item) => ({
            ...item,
            IsGst: true,
          }));
          dispatch(setCommercialQuickQuotes(updatedData));
          //console.log(data)
          //dispatch(quick_quotes_Bike(data));
          dispatch(setQuickQuotePost(updatedQuotePost));
          setLoading(false);
          setisModalReg(false);
          // } else {
          // setLoading(false)
          // message.error(res.data.error.validationMessages.join(","));
          // }
        }
      })
      .catch((err) => {
        console.log(err.response.data.error);
        setLoading(false);
        message.error(err.response.data.error);
      });
  };
  return (
    <>
      <Form onFinish={onFinish} requiredMark={false} layout="vertical">
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              // className="form-item-bg"
              name="registrationDate"
              label="Registration Year"
              rules={[
                {
                  required: true,
                  message: "Please select Year",
                },
              ]}
              initialValue={moment(QuickQuotePost?.registrationDate)}
            >
              <DatePicker
                style={{ width: "100%" }}
                // disabledDate={disabledDate}
                // onChange={handleDateChange}
                format="YYYY-MM-DD"
                placeholder="Select Registration Year"
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              // className="form-item-bg"
              name="vechicleOwned"
              label="Owner Type"
              rules={[
                {
                  required: true,
                  message: "Please select",
                },
              ]}
              initialValue={QuickQuotePost?.policyHolderType}
            >
              <Radio.Group
                className="py-3 px-3 bg-white ant-radio-layout"
                style={{
                  width: "100%",
                }}
              >
                <Radio value="INDIVIDUAL">Individual</Radio>
                <Radio value="ORGANISATION">Organisation</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              // className="form-item-bg"
              label="previous insurer"
              name="customertype"
              rules={[
                {
                  required: true,
                  message: "Please select previous insurer",
                },
              ]}
              initialValue={QuickQuotePost?.previousInsurerCode}
            >
              <Select
                defaultValue="Select your option"
                showSearch
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                // onChange={handleChange}
                options={CommerDetail?.previousInsurerList?.map((p) => ({
                  key: p.id,
                  value: p.code,
                  label: p.name,
                }))}
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item style={{ textAlign: "center" }}>
          <Button
            type="primary"
            loading={loading}
            htmlType="submit"
            className="update-qut-button"
          >
            Update
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
